import { useTranslation } from 'react-i18next';
import { Field, Label, Select, ValidationMessage } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';

import { VentilasjonVarmegjenvinningsType } from '../../../../../../components/registering/utils/registerEnums';
import { VentilasjonFormData } from '../types';

export const VarmegjenvinnerSelect = () => {
  const { t } = useTranslation();
  const { register, formState } = useFormContext<VentilasjonFormData>();

  return (
    <Field>
      <Label>{t('register.ventilation.form.vermegjenvinning.type.label')}</Label>
      <Select
        aria-invalid={!!formState.errors.gjenvinningsType}
        {...register('gjenvinningsType', {
          required: t('register.oppvarming.form.gjennvinningstype.missing'),
          shouldUnregister: true
        })}
        defaultValue=""
        width="full"
      >
        <Select.Option disabled value=""></Select.Option>

        <Select.Option value={VentilasjonVarmegjenvinningsType.VentilasjonMedBatterigjenvinner}>
          {t(
            `register.ventilation.gjenvinningsType.option.${VentilasjonVarmegjenvinningsType.VentilasjonMedBatterigjenvinner}`
          )}
        </Select.Option>
        <Select.Option value={VentilasjonVarmegjenvinningsType.VentilasjonMedPlategjenvinner}>
          {t(
            `register.ventilation.gjenvinningsType.option.${VentilasjonVarmegjenvinningsType.VentilasjonMedPlategjenvinner}`
          )}
        </Select.Option>
        <Select.Option value={VentilasjonVarmegjenvinningsType.VentilasjonMedRoterendeGjenvinner}>
          {t(
            `register.ventilation.gjenvinningsType.option.${VentilasjonVarmegjenvinningsType.VentilasjonMedRoterendeGjenvinner}`
          )}
        </Select.Option>
        <Select.Option value={VentilasjonVarmegjenvinningsType.VentilasjonMedKammergjenvinner}>
          {t(
            `register.ventilation.gjenvinningsType.option.${VentilasjonVarmegjenvinningsType.VentilasjonMedKammergjenvinner}`
          )}
        </Select.Option>
        <Select.Option value={VentilasjonVarmegjenvinningsType.Ukjent}>
          {t(`register.ventilation.gjenvinningsType.option.${VentilasjonVarmegjenvinningsType.Ukjent}`)}
        </Select.Option>
      </Select>
      {formState.errors.gjenvinningsType && (
        <ValidationMessage data-color="danger">{formState.errors.gjenvinningsType.message}</ValidationMessage>
      )}
    </Field>
  );
};
